export const random = (ln: number): string => {
  let result: string = "";
  let characters: string = "abcd0123456789";
  let charactersLength: number = characters.length;
  for ( let i: number = 0; i < ln; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
